import { navigate } from 'gatsby';
import { ORANGE_CARPET_URL } from 'gatsby-env-variables';

import isClient from '@mobi/utils/browser/isClient';

import { session } from 'utils/storage';

/* global ROUTES */

const STEPS_PATH = {
  orange_carpet: ORANGE_CARPET_URL,
  document_product_page: ROUTES.home.path,
  cpf: ROUTES.document.path,
  nome: ROUTES.name.path,
  email: ROUTES.email.path,
  celular: ROUTES.cellphone.path,
  otp: ROUTES.otp.path,
  redirect: ROUTES.redirect.path,
};

const handleStepPath = (stepName) => {
  return STEPS_PATH[stepName] || `/`;
};

const sourceUrlPathname = () => {
  if (!isClient()) return null;

  const sourceUrl = session.getItem('source-url') || '';
  const startedAtProposal = sourceUrl && sourceUrl.includes('step');
  const pathnameToRedirect = sourceUrl && new URL(sourceUrl).pathname;

  return startedAtProposal ? '/' : pathnameToRedirect;
};

const handleOpenAccountLink = (e) => {
  e.preventDefault();

  navigate(ROUTES.document.path);
};

export default {
  handleStepPath,
  sourceUrlPathname,
  handleOpenAccountLink,
};
